/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";
import lightImg from "../../assets/images/svg/OurGoal.webp";
import aboutOne from "../../assets/images/all-img/WhoWeAre.webp";
import targetImg from "../../assets/images/svg/OurVision.webp";
import { Link } from "react-router-dom"; // Import Link for navigation

const About = () => {
  const { t, i18n } = useTranslation(); // Initialize translation

  return (
    <div className="about-area section-padding">
      <div className="container">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
          <div>
            <img src={aboutOne} alt="aboutOne" className="mx-auto" />
          </div>
          <div>
            <div className="mini-title">{t("about.subtitle")}</div>
            <h5 className="column-title">
              {t("about.title")}{" "}
              {/* <span className="shape-bg">{t("about.subtitle")}</span> */}
            </h5>
            <div>{t("about.description")}</div>
            <ul className="list-item space-y-6 pt-8">
              <li className="flex">
                <div
                  className={`flex-none ${
                    i18n.language == "en" ? "mr-6" : "ml-6"
                  } `}
                >
                  <div className="h-[72px] w-[72px] rounded-full">
                    <img
                      src={lightImg}
                      alt="lightImg"
                      className="w-full h-full object-cover rounded-full block"
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl mb-1">{t("about.goal_title")}</h4>
                  <div>{t("about.goal_description")}</div>
                </div>
              </li>
              <li className="flex">
                <div
                  className={`flex-none ${
                    i18n.language == "en" ? "mr-6" : "ml-6"
                  } `}
                >
                  <div className="h-[72px] w-[72px] rounded-full">
                    <img
                      src={targetImg}
                      alt="targetImg"
                      className="w-full h-full object-cover rounded-full block"
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl mb-1">{t("about.vision_title")}</h4>
                  <div>{t("about.vision_description")}</div>
                </div>
              </li>
            </ul>
            <div className="pt-8">
              <Link to="/about" className="btn btn-primary">
                {t("about.read_more")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
